import Module from './Module';
import { LoaderModule } from './LoaderModule';
import ImageLoader from '../../loader/ImageLoader';
import imageUrls from '../../url/image-urls';

/**
 * This Module loads images contained in the DOM, whereas they are <img>, <picture>, or css background-images.
 * 
 * @extends Module
 * @category bootstrap
 * @author Geoffrey Mayeux
 */
class ImageLoaderModule extends Module{
	constructor(bootstrap){
		super(bootstrap);

		this.dependencies.add(LoaderModule);

		this.loader = new ImageLoader();
		this.selector = "";
		this.gather = () => [];
	}

	get loaderModule(){
		return this.bootstrap.get(LoaderModule);
	}

	async before(){
		this.loader.reset();
		if(!this.loaderModule.loader.has(this.loader))
			this.loaderModule.loader.add(this.loader);
	}

	async run(){
		this.loader.add(imageUrls(document.body, this.selector));
		this.loader.add(this.gather());
		await this.loaderModule.loader.load();
	}
}

export default ImageLoaderModule;
export { ImageLoaderModule };